import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  jsonLD?: object;
  noIndex?: boolean;
}

const setMeta = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
};

const setCanonical = (href: string) => {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = 'canonical';
    document.head.appendChild(el);
  }
  el.href = href;
};

const setJsonLD = (data: object) => {
  let el = document.querySelector('script[data-seo="jsonld"]') as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-seo', 'jsonld');
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

const SEOHead = ({ title, description, keywords, canonical, jsonLD, noIndex }: SEOProps) => {
  useEffect(() => {
    document.title = title;
    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (canonical) setCanonical(canonical);
    if (jsonLD) setJsonLD(jsonLD);
    if (noIndex) {
      setMeta('robots', 'noindex, nofollow, noarchive');
      setMeta('googlebot', 'noindex, nofollow');
    }
  }, [title, description, keywords, canonical, jsonLD, noIndex]);

  return null;
};

export default SEOHead;
